<template>
  <div>
    <va-modal
      :title="idformation_lieux ? 'Modifier le lieu' : 'Créer un lieu'"
      class="modal activity"
      v-model="showCreateLieu"
      cancelClass="none"
      :okText="idformation_lieux ? 'Modifier le lieu' : 'Créer le lieu'"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="saveLieu"
      v-on:cancel="closeModal"
      hideDefaultActions
      noEscDismiss
      noOutsideDismiss
    >
      <div class="forcewidth-inside">
        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>

        <div class="row row-inside">
          <div class="flex md12 pa-2">
            <va-input
              label="Nom du lieu"
              v-model="newLieu.nom"
            />
          </div>
          <div class="flex md6 pa-2">
            <va-input
              label="Contact"
              placeholder="M. Dupont"
              v-model="newLieu.contact"
            />
          </div>
          <div class="flex md6 pa-2">
            <va-input
              label="Capacité"
              placeholder="Nombre maximum de participants"
              v-model="newLieu.capacite"
            />
          </div>
          <div class="flex md6 pa-2">
            <va-input
              label="Téléphone"
              v-model="newLieu.telephone"
            />
          </div>
          <div class="flex md6 pa-2">
            <va-input
              label="Email"
              v-model="newLieu.email"
            />
          </div>
          <div class="flex md12 pa-2">
            <va-input
              label="Commentaire"
              v-model="newLieu.commentaires"
            />
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md6 pa-2">
            <va-input
              label="Adresse"
              v-model="newLieu.adresse.adresse"
            />
          </div>
          <div class="flex md6 pa-2">
            <va-input
              label="Complément"
              v-model="newLieu.adresse.complement"
            />
          </div>
          <div class="flex md3 pa-2">
            <va-input
              label="Code postal"
              v-model="newLieu.adresse.code_postal"
              @change="lookupVille"
            />
          </div>
          <div class="flex md6 pa-2">
            <va-input
              label="Ville"
              v-model="newLieu.adresse.ville"
            />
          </div>
          <div class="flex md3 pa-2">
            <va-input
              label="Cedex"
              v-model="newLieu.adresse.cedex"
            />
          </div>

        </div>
      </div>
      <template v-slot:actions>
        <div class="va-modal__actions mb-3">
          <va-button color="gray" flat @click="closeModal">Annuler</va-button>
          <va-button @click="saveLieu">
            {{ idformation_lieux ? 'Modifier le lieu' : 'Créer le lieu' }}
          </va-button>
        </div>
      </template>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["value", "idformation_lieux"],
  data() {
    return {
      showCreateLieu: false,
      errorMessage: "",
      newLieu: {
        nom: null,
        telephone: null,
        email: null,
        commentaires: null,
        capacite: null,
        contact: null,
        adresse: {
          code_postal: null,
          ville: null,
          adresse: null,
          complement: null,
          cedex: null,
        }
      }
    };
  },
  mounted() {
    this.resetForm();
    this.showCreateLieu = this.value;
  },
  watch: {
    value() {
      this.showCreateLieu = this.value;
      if (this.idformation_lieux) {
        this.loadLieu();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    async loadLieu() {
      try {
        const response = await axios.get("/api/afpf/get-lieu/", {
          params: {
            idformation_lieux: this.idformation_lieux,
          },
        });
        let adresse = {
          id: response.data.id || null,
          code_postal: response.data.code_postal || null,
          ville: response.data.ville || null,
          adresse: response.data.adresse || null,
          complement: response.data.complement || null,
          cedex: response.data.cedex || null,
        }
        this.newLieu = {
          idformation_lieux: this.idformation_lieux,
          nom: response.data.nom || null,
          telephone: response.data.telephone || null,
          email: response.data.email || null,
          commentaires: response.data.commentaires || null,
          capacite: response.data.capacite || null,
          contact: response.data.contact || null,
          adresse: adresse
        }
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du chargement du lieu");
      }
    },
    resetForm() {
      this.errorMessage = "";
      this.newLieu = {
        nom: null,
        telephone: null,
        email: null,
        commentaire: null,
        capacite: null,
        contact: null,
        adresse: {
          code_postal: null,
          ville: null,
          adresse: null,
          complement: null,
          cedex: null,
        }
      };
    },
    async saveLieu() {
      console.log("saveLieu");
      this.errorMessage = "";
      const nom = (this.newLieu.nom || "").toString().trim();
      const adresse = (this.newLieu.adresse.adresse || "").toString().trim();
      const codePostal = (this.newLieu.adresse.code_postal || "").toString().trim();
      const ville = (this.newLieu.adresse.ville || "").toString().trim();
      const capaciteRaw = (this.newLieu.capacite === null || this.newLieu.capacite === undefined
        ? ""
        : this.newLieu.capacite
      ).toString().trim();
      const capaciteNumber = capaciteRaw === "" ? NaN : Number(capaciteRaw);

      if (!nom) {
        this.errorMessage = "Le nom du lieu est obligatoire";
        this.launchEpicmaxToast(this.errorMessage);
        return;
      } else if (!capaciteRaw) {
        this.errorMessage = "La capacité du lieu est obligatoire";
        this.launchEpicmaxToast(this.errorMessage);
        return;
      } else if (!Number.isInteger(capaciteNumber)) {
        this.errorMessage = "La capacité doit être un nombre entier";
        this.launchEpicmaxToast(this.errorMessage);
        return;
      } else if (!adresse) {
        this.errorMessage = "L'adresse du lieu est obligatoire";
        this.launchEpicmaxToast(this.errorMessage);
        return;
      } else if (!codePostal) {
        this.errorMessage = "Le code postal du lieu est obligatoire";
        this.launchEpicmaxToast(this.errorMessage);
        return;
      } else if (!ville) {
        this.errorMessage = "La ville du lieu est obligatoire";
        this.launchEpicmaxToast(this.errorMessage);
        return;
      }

      this.newLieu.nom = nom;
      this.newLieu.capacite = capaciteNumber;
      this.newLieu.adresse.adresse = adresse;
      this.newLieu.adresse.code_postal = codePostal;
      this.newLieu.adresse.ville = ville;

      if (this.newLieu.idformation_lieux) {
        try {
          const response = await axios.put("/api/afpf/update-lieu", this.newLieu);
          this.launchEpicmaxToast("Salle mise à jour avec succès");
          this.$emit("update");
          this.closeModal();
        } catch (error) {
          console.log(error);
          this.errorMessage = "Erreur lors de la mise à jour de la salle";
          this.launchEpicmaxToast(this.errorMessage);
          return
        }

      } else {
        this.newLieu.idformation_lieux = null;
        try {
          const response = await axios.post("/api/afpf/create-lieu", this.newLieu);
          this.launchEpicmaxToast("Salle créée avec succès");
          this.$emit("create");
          this.closeModal();
        } catch (error) {
          console.log(error);
          this.errorMessage = "Erreur lors de la création de la salle";
          this.launchEpicmaxToast(this.errorMessage);
          return
        }
      }


      // todo : emit id nouveau lieu

    },
    closeModal() {
      this.showCreateLieu = false;
      this.resetForm();
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    async lookupVille() {
      const codePostal = this.newLieu.adresse.code_postal;
      
      // Only lookup if postal code is entered and ville is empty
      if (!codePostal || this.newLieu.adresse.ville) {
        return;
      }

      // French postal codes are 5 digits
      if (codePostal.length !== 5) {
        return;
      }

      try {
        const response = await axios.get(`/api/communes/insee/${codePostal}`);
        
        if (response.data.data && response.data.data.length > 0) {
          this.newLieu.adresse.ville = response.data.data[0].Nom_de_la_commune;
        }
      } catch (error) {
        console.log("Erreur lors de la recherche de la ville:", error);
        // Silent fail - user can still enter ville manually
      }
    },

  },

}
</script>

<style>
.forcewidth-inside {
  width: 40vw;

  overflow: auto;
}
.error-message {
  color: #b42318;
  margin: 0 0 12px 0;
  font-weight: 600;
}
</style>
